<template>
  <div v-html="subData" ></div>
</template>

<script>
export default {
  props: ["subData"],
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/dialog/htmlTemplate.vue